/**
 * Translation utility functions
 * Simple helper functions for using translations in components
 */

import { getTranslation, getTranslations, TranslationMap } from '../config/translations';

/**
 * Hook-like function to get translations for a specific language
 * Returns a function that can be used to get individual translations
 */
export function useTranslations(languageCode: string) {
    const t = (key: keyof TranslationMap): string => {
        return getTranslation(key, languageCode);
    };

    return t;
}

/**
 * Get all translations for a language as an object
 * Useful when you need multiple translations in a component
 */
export function getTranslationObject(languageCode: string): TranslationMap {
    return getTranslations(languageCode);
}

/**
 * Format a translation with parameters
 * Example: formatTranslation('welcomeMessage', 'en', { name: 'John' })
 * For now, this is a simple implementation - can be extended later
 */
export function formatTranslation(
    key: keyof TranslationMap,
    languageCode: string,
    params?: Record<string, string>
): string {
    let translation = getTranslation(key, languageCode);

    if (params) {
        Object.entries(params).forEach(([paramKey, paramValue]) => {
            translation = translation.replace(`{${paramKey}}`, paramValue);
        });
    }

    return translation;
}
